import { render, staticRenderFns } from "./StockDispatch.vue?vue&type=template&id=3f328592&"
import script from "./StockDispatch.vue?vue&type=script&lang=js&"
export * from "./StockDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockDispatch.vue"
export default component.exports